import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayersSingle16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconLayersSingle16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13.487 8 8.01 4.872 2.533 8l5.477 3.128zM8.506 4.004a1 1 0 0 0-.992 0L1.277 7.566a.5.5 0 0 0 0 .868l6.237 3.562a1 1 0 0 0 .992 0l6.237-3.562a.5.5 0 0 0 0-.868z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayersSingle16);
